import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  CircularProgress,
  Avatar,
  FormHelperText,
  Select,
  MenuItem,
} from "@mui/material";
// import { debounce } from "lodash";
// import { updateRcoin } from "../../DAL/update";
import { useNavigate } from "react-router-dom";
import { AddDiamonds } from "../../DAL/create";
import { useSnackbar } from "notistack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { searchUser } from "../../DAL/fetch";
import { debounce } from "lodash";
import { fileUrl } from "../../Config/Config";

const AddDiamond = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [searchLoading, setLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState([]);
  const [coinData, setCoinData] = useState("");
  const [type, setType] = useState(false);
  const [reason, setReason] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [inputs, setInputs] = useState({
    userCode: "",
    diamond: "",
    type: "send_diamond_by_admin",
    reason: "",
  });

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddDiamond = async () => {
    setSendLoading(true);

    try {
      const payload = {
        userCode: inputs.userCode,
        diamond: inputs.diamond,
        type: inputs.type,
        reason: inputs.reason,
      };
      const response = await AddDiamonds(payload);
      if (response.status == 200) {
        enqueueSnackbar(response?.data?.message, { variant: "success" });
        navigate("/diamond-list");
        setData("");
      } else {
        enqueueSnackbar(response?.error || response?.message, {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    } finally {
      setSendLoading(false);
    }
  };

  const searchData = async () => {
    setLoading(true);

    try {
      const response = await searchUser({ codes: searchTerm });
      if (response && response.data) {
        const user = Array.isArray(response.data.data)
          ? response.data.data[0]
          : response.data;
        setData([user]);
      }
    } catch (error) {
      enqueueSnackbar("Search failed", { variant: "error" });
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const debounceSearch = useCallback(
    debounce((query) => {
      setSearchTerm([query]);
    }, 1000),
    []
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, userCode: value }));
    debounceSearch(value);
  };

  useEffect(() => {
    if (searchTerm.length > 0 && searchTerm[0].length === 8) {
      searchData();
    }
  }, [searchTerm]);

  const labelStyles = {
    color: "",
    "&.Mui-focused": {
      color: "#8F29D0",
    },
  };
  const inputStyles = {
    marginBottom: 2,
    marginTop: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0",
      },
    },
  };

  return (
    <>
      <ArrowBackIcon
        onClick={() => navigate(-1)}
        sx={{ padding: "10px", cursor: "pointer" }}
      />
      <div className="wallet-area">
        <div className="Wallet-form">
          <Typography variant="h5">
            <b>Send Diamonds</b>
          </Typography>
          {data[0]?.name && (
            <>
              <Avatar
                alt={data[0]?.name}
                src={
                  data[0]?.picture?.startsWith("http")
                    ? data[0]?.picture
                    : fileUrl + data[0]?.picture
                }
                sx={{ height: "100px", width: "100px", margin: "10px" }}
              />
              <Typography variant="h5">{data[0]?.name}</Typography>
            </>
          )}
          <Box>
            <TextField
              fullWidth
              label="User RID *"
              variant="outlined"
              size="small"
              type="number"
              value={inputs.userCode}
              name="userCode"
              onChange={handleSearch}
              sx={inputStyles}
              InputLabelProps={{ sx: labelStyles }}
            />
            <TextField
              fullWidth
              label="Enter Diamond *"
              variant="outlined"
              size="small"
              value={inputs.diamond}
              name="diamond"
              type="number"
              onChange={handleChange}
              sx={inputStyles}
              InputLabelProps={{ sx: labelStyles }}
            />

            <TextField
              fullWidth
              label="Reason "
              variant="outlined"
              size="small"
              type="text"
              multiline
              rows={3}
              value={inputs.reason}
              name="reason"
              onChange={handleChange}
              sx={inputStyles}
              InputLabelProps={{ sx: labelStyles }}
            />

            <Button
              fullWidth
              variant="contained"
              onClick={handleAddDiamond}
              className="gradientButton"
              disabled={sendLoading || searchLoading}
              sx={{ textTransform: "none" }}
            >
              {sendLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Send Diamond"
              )}
            </Button>
          </Box>
        </div>
      </div>
    </>
  );
};

export default AddDiamond;
